import _bundle from '../../core/core--bundles';
import corporateQuestions, { saveCorporateQuestions } from '../dashboards/accrual/corporate-questions';
import { showErrorNotification, showSuccessNotification } from '../global/notifications';
import { getPrevQtEnd } from '../global/fiscal-year';

const company = $('[name=Company]').val();
let _approved = $('.js-approved').val() === 'True';
let activeTab = $('.menu-topbar__link.--active').text();
let previousTab = activeTab;

export default function () {
    initiateGridTab();
    initiateCorporateQuestionTab();

    _bundle.add({
        name: 'SgaBurden : Tab Change',
        event: ['on:TabChange'],
        fn() {
            activeTab = $('.menu-topbar__link.--active').text();
            if (activeTab !== previousTab) {
                loadTab()
                    .finally(_ => {
                        console.debug("done!");
                        previousTab = activeTab;
                    });
            }
        }
    });
}

const loadTab = () => {
    return new Promise((resolve, reject) => {
        if (activeTab === '') activeTab = $('.menu-topbar__link.--active').text() || 'SG&A/Burden/Other';
        if (activeTab === 'Corporate Questions') {
            $('.js-sga-corporate-questions-tab').html('').load('/Finance/SgaBurdenCorporateQuestionsTab', {company: company}, function () {
                initiateCorporateQuestionTab();
                resolve();
            });
        } else if (activeTab === 'SG&A/Burden/Other') {
            let $sgaGrid = $('.js-sga-grid');

            if ($sgaGrid.length) {
                let k_sgaGrid = $sgaGrid.data('kendoGrid');
                if (k_sgaGrid) {
                    k_sgaGrid.dataSource.read()
                } else {
                    reloadGrid();
                }
            }
        }
    });
}
const reloadGrid = () => {
    return new Promise((resolve, reject) => {
        $('.js-sga-grid-tab').load('/Finance/SgaBurdenGridTab', {company: company}, function () {
            initiateGridTab();
            resolve();
        });
    })

}
const initiateGridTab = () => {
    createSgaInvoiceGrid();
    updateExplanationEvent();
    gridApproval();
}
const createSgaInvoiceGrid = () => {
    let $sgaGrid = $('.js-sga-grid');

    if ($sgaGrid.length) {
        let k_sgaGrid = $sgaGrid.data('kendoGrid');
        _approved = $('.js-approved').val() === 'True';
        if (k_sgaGrid) {
            k_sgaGrid.dataSource.read()
        } else {
            $sgaGrid.kendoGrid({
                columns: [
                    {
                        field: 'invoiceDesc',
                        title: 'Description',
                        template: function (dataItem) {
                            return `<div>${dataItem.invoiceDesc}<span class='k-icon k-i-attachment-45' data-kendoWindow="SgaAttachmentWindow" data-role="openKendoWindow" data-vendor="${dataItem.vendorNum}" data-apRef="${dataItem.apRef}" data-invId="${dataItem.invID}" style="margin-left:5px;"></span></div>`;
                        },
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'vendorNum',
                        title: 'Vendor',
                        template: function (dataItem) {
                            return `<div>${dataItem.vendorNum} - ${dataItem.vendorName}</div>`;
                        },
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'apRef',
                        title: 'AP Ref',
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'invDate',
                        title: 'Invoice Date',
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        format: '{0: M/d/yyyy}',
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'job',
                        title: 'Invoice Information',
                        headerAttributes: {style: 'white-space: normal'},
                        template: function (dataItem) {
                            let job = dataItem.job,
                                purchaseOrder = dataItem.purchaseOrder,
                                workOrder = dataItem.workOrder,
                                subcontract = dataItem.subContract,
                                finalOutput = "";

                            if (job) {
                                finalOutput = addNewLine(finalOutput, `Project: ${job}`)
                            }
                            if (purchaseOrder) {
                                finalOutput = addNewLine(finalOutput, `PO: ${purchaseOrder}`)
                            }
                            if (workOrder) {
                                finalOutput = addNewLine(finalOutput, `WO: ${workOrder}`)
                            }
                            if (subcontract) {
                                finalOutput = addNewLine(finalOutput, `SUB: ${subcontract}`)
                            }

                            return finalOutput;
                        },
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'costSegment',
                        title: 'GL/Segment',
                        editor: segmentDropDownEditor,
                        values: segmentData,
                        template: function (dataItem) {
                            if (_approved) {
                                return dataItem.costSegment;
                            }

                            let output = '<div class="t-blue">Click to Assign</div>';
                            output += `<div>${dataItem.costSegment}</div>`;

                            if (dataItem.accrualRequired === 1 && dataItem.costSegment === '') {
                                output += '<div><span class="tag tag--small tag--red">Selection Required</span></div>';
                            }
                            return output;
                        },
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'invAmount',
                        title: 'Amount',
                        headerAttributes: {style: 'white-space: normal'},
                        format: '{0: ##,#.00}',
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'accrualRequired',
                        title: 'Accrual Required',
                        // editor: accrualRequiredCheckBoxEditor,
                        template: function (dataItem) {
                            if (_approved) {
                                let output = `<div style="text-align: center">${dataItem.accrualRequired === 1 ? 'Yes' : 'No'}`;
                                if (dataItem.explanation != null && dataItem.explanation.length) {
                                    output += `<span class="js-explanation-icon icon icon--comment-has" data-kendoWindow="SgaExplanationWindow" data-role="openKendoWindow" data-invId="${dataItem.invID}"></span>`
                                }
                                output += '</div>';
                                return output;
                            }

                            let output = `<div style="text-align: center"><input type="checkbox" name="accrualRequired" class="k-checkbox" ${dataItem.accrualRequired === 1 ? 'checked=checked' : ''} style="margin-right: 10px;" data-invId="${dataItem.invID}" data-type="${dataItem.type}"/><span class="js-explanation-icon icon ${dataItem.explanation != null && dataItem.explanation.length > 0 ? 'icon--comment-has' : 'icon--comment-add'}" data-kendoWindow="SgaExplanationWindow" data-role="openKendoWindow" data-invId="${dataItem.invID}"></span></div>`;
                            if (isExplanationRequired(dataItem)) {
                                output += '<div><span class="tag tag--small tag--red">Explanation Required</span></div>';
                            }
                            return output;
                        },
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    },
                    {
                        field: 'sourceReport',
                        title: 'Source',
                        headerAttributes: {style: 'white-space: normal'},
                        filterable: false,
                        sortable: {
                            mode: "single",
                            allowUnsort: true
                        }
                    }],
                dataSource: {
                    transport: {
                        read: {
                            url: `/Finance/GetSgaBurdenInvoices?company=${company}`,
                            type: 'GET',
                            dataType: 'json'
                        },
                        update: {
                            url: '/Finance/UpdateSgaBurdenInvoices',
                            type: 'PUT',
                            dataType: 'application/json; charset=utf-8'
                        }, parameterMap: function (data, type) {
                            let rs = {};
                            if (type === 'read') {
                                return rs;
                            }
                            if (type === 'update') {
                                return rs;
                            }
                        }
                    },
                    pageSize: 20,
                    schema: {
                        model: {
                            fields: {
                                row: {editable: false},
                                invID: {editable: false, type: "number"},
                                yr: {editable: false, type: "number"},
                                mo: {editable: false, type: "number"},
                                runDate: {editable: false, type: "date"},
                                sourceReport: {editable: false, type: "string"},
                                company: {editable: false, type: "number"},
                                companyName: {editable: false, type: "string"},
                                invoiceDesc: {editable: false, type: "string"},
                                apRef: {editable: false, type: "string"},
                                invDate: {editable: false, type: "date"},
                                vendorNum: {editable: false, type: "number"},
                                vendorName: {editable: false, type: "string"},
                                invAmount: {editable: false, type: "number"},
                                job: {editable: false, type: "string"},
                                workOrder: {editable: false, type: "number"},
                                purchaseOrder: {editable: false, type: "string"},
                                subContract: {editable: false, type: "string"},
                                accrualRequired: {editable: false, type: "bool"},
                                costSegment: {type: "string"},
                                explanation: {type: "string"}
                            }
                        }
                    }
                },
                resizable: false,
                mobile: false,
                scrollable: true,
                sortable: {
                    mode: 'single',
                    allowUnsort: true
                },
                filterable: true,
                editable: !_approved,
                dataBound(e) {
                    // Setup month and year
                    let $manualWindow = $('#ManualInvoiceWindow'),
                        allData = e.sender.dataSource._data,
                        data = allData[0];

                    if (data) {
                        $manualWindow.data('month', data.mo);
                        $manualWindow.data('year', data.yr);
                    } else {
                        let qtEnd = getPrevQtEnd();
                        $manualWindow.data('month', qtEnd.getMonth() + 1);
                        $manualWindow.data('year', qtEnd.getFullYear());
                    }

                    $('.js-explanation-icon').click(function () {
                        let $window = $('#SgaExplanationWindow');
                        $window.data('invId', $(this).data('invid'));
                    });

                    $('.k-icon.k-i-attachment-45').click(function () {
                        let $window = $('#SgaAttachmentWindow');
                        $window.data('vendor', $(this).data('vendor'));
                        $window.data('invId', $(this).data('invid'));
                        $window.data('apRef', $(this).data('apref'));
                    });

                    //Bind update logic
                    accrualRequiredChange();

                    //Time to get those totals
                    getSgaSegmentTotals(allData);

                    if (!_approved) {
                        $('td[data-field="costSegment"]').css('cursor', 'pointer');
                    }

                    // Bind Window Trigger for grid items
                    $(document).trigger('on:PageUpdate');
                },
                pageable: {
                    alwaysVisible: false,
                    pageSizes: true,
                    buttonCount: 20
                }
            })
        }
    }
}
const segmentData = [
    {text: "Burden - Construction", value: "Burden - Construction"},
    {text: "Burden - Service", value: "Burden - Service"},
    {text: "SG&A - Construction", value: "SG&A - Construction"},
    {text: "SG&A - Service", value: "SG&A - Service"},
    {text: "Project - Construction", value: "Project - Construction"},
    {text: "Project - Service", value: "Project - Service"},
    {text: "Project - Interc Construction", value: "Project - Interc Construction"},
    {text: "Project - Interc Service", value: "Project - Interc Service"},
    {text: "Work Order - Service", value: "Work Order - Service"}
];
const segmentDropDownEditor = (container, options) => {
    if (_approved) return;
    $('<input name="' + options.field + '"/>')
        .appendTo(container)
        .kendoDropDownList({
            autoBind: true, dataTextField: 'text', dataValueField: 'value', dataSource: {
                type: 'json', data: segmentData
            }
        })
        .on('change', function () {
            let data = {
                Id: options.model.invID,
                InvoiceNumber: options.model.apRef,
                Segment: this.value
            }

            updateInvoiceData(data)
                .then(_ => {
                    $('.js-sga-grid').data('kendoGrid').dataSource.read();
                });
        });
}
const addNewLine = (original, addition) => {
    if (original.length > 0) {
        return original + '\n' + addition;
    }
    return addition;
}
const updateExplanationEvent = () => {
    let $window = $('#SgaExplanationWindow');
    let $explanation = $window.find('.js-explanation');

    $('#updateExplanation').click(function () {
        let data = {
            Id: $window.data('invId'),
            Explanation: $explanation.val()
        }

        updateInvoiceData(data)
            .then(_ => {
                $('.js-sga-grid').data('kendoGrid').dataSource.read();
            });
    });
}
const accrualRequiredChange = () => {
    let $checkboxes = $('[name=accrualRequired]');

    $checkboxes.on('change', function () {
        let $this = $(this),
            data = {
                Id: $this.data('invid'),
                InvoiceNumber: $this.data('apref'),
                AccrualRequired: !!$this.prop('checked'),
                TypeIndex: $this.data('type')
            }

        updateInvoiceData(data)
            .then(_ => {
                $('.js-sga-grid').data('kendoGrid').dataSource.read();
            });
    })
}
const updateInvoiceData = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Finance/UpdateSgaBurdenInvoices', data, function (response) {
            if (response) {
                resolve();
            } else {
                reject();
            }
        });
    })
}
const getSgaSegmentTotals = (data) => {
    let allTotal = 0,
        burdenConstructionTotal = 0,
        burdenServiceTotal = 0,
        sgaConstructionTotal = 0,
        sgaServiceTotal = 0,
        projectConstructionTotal = 0,
        projectServiceTotal = 0,
        projectIntercConstructionTotal = 0,
        projectIntercServiceTotal = 0,
        workOrderServiceTotal = 0,
        otherSegment = 0;

    $.each(data, function (index, ele) {
        if (ele.accrualRequired) {
            switch (ele.costSegment) {
                case segmentData[0].value : {
                    burdenConstructionTotal += ele.invAmount;
                    break;
                }
                case segmentData[1].value : {
                    burdenServiceTotal += ele.invAmount;
                    break;
                }
                case segmentData[2].value : {
                    sgaConstructionTotal += ele.invAmount;
                    break;
                }
                case segmentData[3].value : {
                    sgaServiceTotal += ele.invAmount;
                    break;
                }
                case segmentData[4].value : {
                    projectConstructionTotal += ele.invAmount;
                    break;
                }
                case segmentData[5].value : {
                    projectServiceTotal += ele.invAmount;
                    break;
                }
                case segmentData[6].value : {
                    projectIntercConstructionTotal += ele.invAmount;
                    break;
                }
                case segmentData[7].value : {
                    projectIntercServiceTotal += ele.invAmount;
                    break;
                }
                case segmentData[8].value : {
                    workOrderServiceTotal += ele.invAmount;
                    break;
                }
                default : {
                    otherSegment += ele.invAmount;
                }
            }
            allTotal += ele.invAmount;
        }
    });

    $('.js-burden-construction-total').text(kendo.toString(burdenConstructionTotal, '##,#.00'))
    $('.js-burden-service-total').text(kendo.toString(burdenServiceTotal, '##,#.00'))
    $('.js-sga-construction-total').text(kendo.toString(sgaConstructionTotal, '##,#.00'))
    $('.js-sga-service-total').text(kendo.toString(sgaServiceTotal, '##,#.00'))
    $('.js-project-construction-total').text(kendo.toString(projectConstructionTotal, '##,#.00'))
    $('.js-project-service-total').text(kendo.toString(projectServiceTotal, '##,#.00'))
    $('.js-project-interc-construction-total').text(kendo.toString(projectIntercConstructionTotal, '##,#.00'))
    $('.js-project-interc-service-total').text(kendo.toString(projectIntercServiceTotal, '##,#.00'))
    $('.js-work-order-service-total').text(kendo.toString(workOrderServiceTotal, '##,#.00'))
    $('.js-other-segment').text(kendo.toString(otherSegment, '##,#.00'))
    $('.js-sga-total').text(kendo.toString(allTotal, '##,#.00'))
}
const gridApproval = () => {
    $('form#SgaApprovalForm [data-role="approval"]').on('click', function (e) {
        e.preventDefault();
        validateExplanations()
            .then(_ => approveSgaGrid())
            .then(_ => reloadGrid())
            .catch((error) => showErrorNotification(error))
    })
}
const approveSgaGrid = () => {
    return new Promise((resolve, reject) => {
        const $form = $('form#SgaApprovalForm');
        $.post('/Finance/SgaBurdenGridApproval', $form.serialize(), function (e) {
            if (e.success) {
                resolve(e.message);
            } else {
                reject(e.message);
            }
        })
    })
}
const validateExplanations = () => {
    return new Promise((resolve, reject) => {
        let rejectReason = '';
        const gridData = $('.js-sga-grid').data('kendoGrid').dataSource.data();
        const itemRequiresExplanation = gridData.find(function (e) {
            return isExplanationRequired(e);
        });
        if (itemRequiresExplanation) {
            rejectReason += 'There are still items that require an explanation';
        }

        const itemsRequireSegmentAssignment = gridData.find(function (e) {
            return e.accrualRequired === 1 && e.costSegment === '';
        });
        if (itemsRequireSegmentAssignment) {
            if (rejectReason.length > 0) {
                rejectReason += '<br/>and<br/>';
            }
            rejectReason += 'There are still items that require an GL/Segment Assignment';
        }

        if (rejectReason.length) {
            reject(rejectReason);
        } else {
            resolve();
        }
    });
}
const isExplanationRequired = (invoice) => {
    const pullDate = new Date(`${invoice.mo}/1/${invoice.yr}`).addMonth(1);
    const isPrior = pullDate > new Date(invoice.invDate);
    const needsExplanation = (isPrior && !invoice.accrualRequired) || (!isPrior && invoice.accrualRequired)
    return needsExplanation && invoice.explanation == null;
}

/* **************************
 * CORPORATE QUESTION_STUFF *
 ************************** */
const initiateCorporateQuestionTab = () => {
    setPanelBar();
    corporateQuestions(0);
    initiateCorporateQuestionsEvent();
    approvalEvent();
    rejectEvent();
    approveNothingEvent();
}
const setPanelBar = () => {
    let $soxPanel = $('.pannelbar--sox-exc');
    if ($soxPanel.length) {
        $soxPanel.kendoPanelBar({
            expandMode: 'multiple'
        });
    }
};
const initiateCorporateQuestionsEvent = () => {
    $('.js-initiate-questions').on('click', function () {
        let $ele = $(this),
            data = {
                apRef: $ele.data('apref'),
                company: $ele.data('company')
            }
        $.post('/Finance/SgaBurdenInitiateCorporateQuestion', data, function () {
            loadTab()
                .finally(_ => {
                    reopenAccrual(data.apRef);
                });
        })
    })
}
const reopenAccrual = (apRef) => {
    $(`[id="Id${apRef}"]`).parents('li.soxexc').find('span.k-link.soxexc__toggle').click()
}
const approvalEvent = () => {
    let $approvalButtons = $('[data-role="approve"]');

    if ($approvalButtons.length) {
        $approvalButtons.on('click', function (e) {
            let $form = $(this).parents('form'),
                data = {
                    pin: $form.find('[type="password"]').val(),
                    apRefNumber: $form.find('[name="ApRefNumber"]').val(),
                    role: $(this).data('approve-as')
                }
            saveCorporateQuestions(this)
                .then(_ => approveSgaBurdenInvoice(data))
                .then(_ => loadTab())
                .then(_ => reopenAccrual(data.apRefNumber))
                .catch(error => {
                    showErrorNotification(error);
                });

        })
    }
}
const rejectEvent = () => {
    let $rejectButton = $('[name=rejectApprovals]');

    if ($rejectButton.length) {
        $rejectButton.on('click', function () {
            let $self = $(this),
                $form = $self.parents('form'),
                apRef = $form.find('[name="ApRefNumber"]').val(),
                data = {
                    apRefNumber: apRef
                };

            rejectSgaBurdenInvoice(data)
                .then()
                .then(_ => loadTab())
                .then(_ => reopenAccrual(apRef))
                .catch(error => {
                    showErrorNotification(error);
                });
        })
    }
};
const approveSgaBurdenInvoice = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Finance/SgaBurdenApproval', data, function (response) {
            if (response === true) {
                resolve("Invoice Approved");
            } else {
                reject(response);
            }
        });
    })
}
const rejectSgaBurdenInvoice = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Finance/RejectSgaBurdenApproval', data, function (response) {
            if (response === true) {
                resolve("Invoice Rejected");
            } else {
                reject(response);
            }
        });
    })
}


/* **************************
 *  NO ACCRUAL APPROVALS    *
 ************************** */
const approveNothingEvent = () => {
    const $approveNothingButton = $('.js-approve-nothing');

    if ($approveNothingButton.length) {
        $approveNothingButton.on('click', function () {
            const pin = $approveNothingButton.parents('form').find('[name="pin"]').val();

            if (pin === '') {
                showErrorNotification("Please Enter Pin");
                return;
            }

            let data = {
                company: company,
                pin: pin
            };

            $.post('/Finance/SgaBurdenNoAccrualApproval', data, function (response) {
                if (response.success === true) {
                    showSuccessNotification('Successfully Approved');
                    loadTab();
                } else {
                    showErrorNotification(response.message);
                }
            })
        });
    }
}
